<template>
  <div class="el-input-time">
    <el-select
      v-if="!this.fixUnit"
      v-model="timeUnitValue"
	  :disabled="disabled"
      placeholder="Select"
    >
      <el-option
        v-for="item in unitOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
    <el-input-number
      v-model="numberValue"
      :min="1"
      :max="maxValue"
	  :disabled="disabled"
      controls-position="right"
    />
    <span class="input-num-unit">{{ timeUnit === "월" ? "개월" : timeUnit }}</span>
  </div>
</template>

<script>
const DAY = 1,
	WEEK = 7;

export default {
	name: "ElInputWeek",
	props: {
		value: {},
		fixUnit: {},
		disabled: {
			default: false,
			type: Boolean
		},
	},
	data() {
		return {
			unitOptions: [
				{
					value: DAY,
					label: "일",
				},
				{
					value: WEEK,
					label: "주",
				},
			],
			currentValue: 0,
			timeUnitValue: 1,
			numberValue: 1,
		};
	},
	computed: {
		timeUnit() {
			return this.unitOptions.find(unit => unit.value === this.timeUnitValue)
				.label;
		},
		maxValue() {
			if (this.timeUnitValue === DAY) {
				return 6;
			} else if (this.timeUnitValue === WEEK) {
				return 12;
			}
		},
	},
	watch: {
		timeUnitValue(value) {
			this.currentValue = value * this.numberValue;

			this.$emit("input", this.currentValue);
		},
		numberValue(value) {
			this.currentValue = value * this.timeUnitValue;

			this.$emit("input", this.currentValue);
		},
		value: {
			immediate: true,
			handler(value) {
				if (value === this.currentValue) {
					return;
				}

				if (this.fixUnit) {
					this.numberValue = value / this.fixUnit;
					return (this.timeUnitValue = this.fixUnit);
				}

				if (value % WEEK === 0) {
					this.numberValue = value / WEEK;
					return (this.timeUnitValue = WEEK);
				}

				this.numberValue = value / DAY;
				return (this.timeUnitValue = DAY);
			},
		},
	},
};
</script>

<style lang="scss">
@import "../../scss/element-custom/components/el-input-time.scss";
</style>
